'use strict';
import Vue from 'vue';

export default {};



// WEBPACK FOOTER //
// ./src/store/features/actions.js